const __WEBPACK_NAMESPACE_OBJECT__ = require("@visa/vds-react/icon-styled");